// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"9238dbe9","739":"573baba8"}[chunkId] + ".chunk.js";
};